// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let FeaturesV3 = require("./FeaturesV3.bs.js");

let useFeatureFlipper = FeaturesV3.useFeatureFlipper;

let jsProvider = FeaturesV3.JsProvider.make;

exports.useFeatureFlipper = useFeatureFlipper;
exports.jsProvider = jsProvider;
/* FeaturesV3 Not a pure module */
